export const warning = {
  name: "warning" as const,
  svg: `<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="currentColor"><path d="M12.995 15.852 13.4 4.554a1.693 1.693 0 1 0-3.385 0l.406 11.298h2.574Zm-1.3 5.382c1.092 0 2.054-.962 2.054-2.028 0-1.04-.962-2.028-2.054-2.028-1.066 0-2.054.988-2.054 2.028 0 1.066.988 2.028 2.054 2.028Z"/></svg>`,
  keywords: ["warning"],
  category: "status" as const,
};
